/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { CurrencyInput, Label } from '@americanexpress/dls-react';

import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import './BW-Currency-Input.scss';
import Selectors from 'src/utils/selectors';

export default class BWCurrencyInput extends Component<any> {
    public override state = {
        error: null as string
    };

    private errorTimer!: number;

    public override render(): ReactComponentElement<any> {
        const helperText = this.props.helperText ? (
            <Typography variant={TypographyVariants.LEGAL_PRIMARY} key="field-helper" className="field-helper">
                {this.props.helperText}
            </Typography>
        ) : null;

        const errorText = this.state.error ? (
            <Typography variant={TypographyVariants.LEGAL_PRIMARY} key="error" className="field-error">
                {this.state.error}
            </Typography>
        ) : (
            helperText
        );

        return (
            <div
                key={this.props.id ? this.props.id : ''}
                data-cy={Selectors.PlanAhead.EDIT_BUDGET_AMOUNT_INPUT}
                className={`currency-field ${this.props.fullWidth ? 'fullWidth' : ''}`}
            >
                {this.props.label ? <Label htmlFor={this.props.id}>{this.props.label}</Label> : null}
                <CurrencyInput
                    id={this.props.id}
                    className={this.props.className}
                    defaultValue={0}
                    status=""
                    value={this.props.value || ''}
                    showFractions={this.props.showFractions}
                    onChange={this.onChange.bind(this)}
                    data-cy={this.props['data-cy']}
                />
                {errorText}
            </div>
        );
    }

    private onChange(e: any): void {
        const value = Number(e.target.value.replace(/[,$]/g, ''));

        if (e.target.value) {
            if (this.props.minValue && value < this.props.minValue) {
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.errorTimer = window.setTimeout(() => {
                    this.setError(this.props.minError);
                }, 300);
            } else if (this.props.maxValue && value > this.props.maxValue) {
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.errorTimer = window.setTimeout(() => {
                    this.setError(this.props.maxError);
                }, 300);
            } else {
                this.setState({
                    error: null
                });
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
            }
        } else {
            if (this.state.error) {
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.setState({
                    error: null
                });
            }
        }

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    private setError(error: string): void {
        this.setState({
            error
        });
    }
}
